import { useState } from "react";
import { TypedFilter } from "odata-query";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  IApiRequest,
  IOrderTemplateResponse,
  PlatformModules,
} from "@miplatform/types";

export const useOrderTemplates = ({
  module = null,
}: IUseOrderTemplates = {}) => {
  const [orderTemplates, setOrderTemplates] = useState<
    IOrderTemplateResponse[]
  >([]);
  const [recentOrderTemplates, setRecentOrderTemplates] = useState<
    IOrderTemplateResponse[]
  >([]);
  const [filter, setFilter] = useState<TypedFilter<IOrderTemplateResponse>>({});

  const stateManager = useComponentState();

  const getOrderTemplates = ({
    top,
    skip,
    filters: requestFilters,
    search = "",
    onSuccess,
    ...rest
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const filters = {
        ...requestFilters,
        ...filter,
        name: { contains: search },
        ...(module ? { module: { eq: module } } : {}),
      };
      const response = await taskService.orderTemplates.getAll({
        top,
        skip,
        filters,
        sort: "name",
        ...rest,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setOrderTemplates(response.data);
        onSuccess?.(response.data);
      }
      return response;
    });
  };

  const getRecentOrderTemplates = ({
    sort,
    top,
    filters,
    onSuccess,
  }: IApiRequest) => {
    return stateManager.run(async () => {
      const response = await taskService.orderTemplates.getAll({
        sort,
        top,
        filters: {
          ...filter,
          ...filters,
          ...(module ? { module: { eq: module } } : {}),
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        setRecentOrderTemplates(response.data);
        onSuccess?.(response.data);
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    orderTemplates,
    setOrderTemplates,
    getOrderTemplates,
    recentOrderTemplates,
    setRecentOrderTemplates,
    getRecentOrderTemplates,
    filter,
    setFilter,
  };
};

interface IUseOrderTemplates {
  module?: PlatformModules | null;
}
